import { render, staticRenderFns } from "./InactivateSelectedButton.vue?vue&type=template&id=12883792&"
import script from "./InactivateSelectedButton.vue?vue&type=script&lang=js&"
export * from "./InactivateSelectedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports